import { createAction, props } from '@ngrx/store';
import { otcCatalog } from 'src/app/pages/orders/interfaces/oneTimeCustomer.interface';

export const loadTaxClass = createAction('[Tax Class] Load');

export const loadTaxClassSuccess = createAction('[Tax Class] Load Success', props<{ response: otcCatalog[] }>());

export const loadTaxClassSuccessByKey = createAction(
  '[Tax Class] Load Success By Key',
  props<{ key: string; response: otcCatalog[] }>(),
);

export const loadTaxClassFailure = createAction('[Tax Class] Load Failure', props<{ error: any }>());
